import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import PostTemplate from "./sections/PostTemplate"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <PostTemplate />
      <Footer />
    </div>
  )
}
